import React from 'react';
import { RouterProps } from '../shared/types/route.type';
import { AppRoutes } from './routeConstants/appRoutes';
import Login from '../views/Login';
import VerifyEmail from '../views/VerifyEmail';
import ForgotPassword from '../views/ForgotPassword';
import SetNewPassword from '../views/SetNewPassword';
import VerifyEmailForgotPass from '../views/VerifyEmailForgotPass';
import PublicRoute from '../shared/components/PublicRoute';
import PrivateRoute from 'shared/components/PrivateRoute';
import PilotSubscription from 'views/PilotSubscription';
import CompanyDetails from 'views/CompanyDetails';
import AdminInfo from 'views/AdminInfo';
import CompanyAddress from 'views/CompanyAddress';

export const authRoutes: RouterProps[] = [
  {
    path: AppRoutes.ADMIN_INFO,
    element: (
      <PublicRoute>
        <AdminInfo />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.COMPANY_DETAILS,
    element: (
      <PrivateRoute>
        <CompanyDetails />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.COMPANY_ADDRESS,
    element: (
      <PrivateRoute>
        <CompanyAddress />
      </PrivateRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.LOGIN_VIEW,
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.VERIFY_EMAIL,
    element: (
      <PublicRoute>
        <VerifyEmail />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.FORGOT_PASS,
    element: (
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.SET_NEW_PASS,
    element: (
      <PublicRoute>
        <SetNewPassword />
      </PublicRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.PLAN_DETAILS,
    element: (
      <PrivateRoute>
        <PilotSubscription />
      </PrivateRoute>
    ),
    children: [],
  },
  {
    path: AppRoutes.FORGOT_PASS_VERIFICATION,
    element: <VerifyEmailForgotPass />,
  },
];
